import {useEffect, useState} from 'react';

/**
 * Forces a component to re-render after it mounts.
 * This is useful for components that depend on refs being set after initial mount,
 * such as popovers that need to calculate their position relative to a target element.
 */
export const useRerenderOnMount = () => {
  const [_rerenderToken, setRerenderToken] = useState(0);
  useEffect(() => {
    // oxlint-disable-next-line react/set-state-in-effect -- the hook's entire purpose is a post-mount rerender tick
    setRerenderToken((prev) => prev + 1);
  }, []);
};
